import React from 'react';

const sortingStatus = {
  0: null,
  1: 'desc',
  2: 'asc',
};

class SortingCaret extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      statusCode: 0,
    };
    this.setStatusCode = this.setStatusCode.bind(this);
  }

  setStatusCode(statusCode) {
    this.setState({
      statusCode,
    });
  }

  render() {
    const {statusCode} = this.state;
    return (
      <span className="sorting-caret">
        <span className={`fa fa-sort${sortingStatus[statusCode] ? `-${sortingStatus[statusCode]}` : ''}`} />
      </span>
    );
  }
}

export default class SortingManager {
  constructor() {
    this.fields = {};
    this.carets = {};
    this.refs = {};
  }

  register(fieldName) {
    this.fields[fieldName] = 0;
    this.carets[fieldName] = <SortingCaret key={fieldName} ref={(ref) => (this.refs[fieldName] = ref)} />;
  }

  clickCaret(fieldName) {
    let sortingFieldStatus;
    for (const [name, cnt] of Object.entries(this.fields)) {
      let statusCode;
      if (fieldName !== name) {
        statusCode = 0;
      } else {
        statusCode = (cnt + 1) % 3;
        sortingFieldStatus = sortingStatus[statusCode];
      }
      this.fields[name] = statusCode;
      this.refs[name].setStatusCode(statusCode);
    }
    return Promise.resolve(sortingFieldStatus);
  }
}
